// The tail of an audit history.
//
// A phase that has been reassigned and re-statused a dozen times pushes everything below it off
// the screen, and the entries anybody actually wants are the most recent ones. So the panel opens
// on the last three and offers the rest.
//
// The server sends the history oldest-first and it is rendered oldest-first, so this takes the
// TAIL and leaves the order alone: reversing "most recent three" into newest-first would make the
// collapsed view read in the opposite direction from the expanded one.
export const RECENT_SUB_TICKET_LOG_COUNT = 3;

export interface RecentSubTicketLogSelection<T> {
    visible: T[];
    // How many entries the toggle is offering. Zero means there is no toggle at all — a control
    // that reveals nothing is worse than no control.
    hiddenCount: number;
}

export const selectRecentSubTicketLogs = <T>(
    logs: T[],
    limit: number = RECENT_SUB_TICKET_LOG_COUNT
): RecentSubTicketLogSelection<T> => {
    const visible = logs.length <= limit ? [...logs] : logs.slice(logs.length - limit);

    return { visible, hiddenCount: logs.length - visible.length };
};
